import { RG_TYPE } from "@project-rouge/rg-core";
function isBuildingEmpty(building) {
	if (!building.children.some((c) => c.type === RG_TYPE.Core)) return true;
	if (!building.children.some((c) => c.type === RG_TYPE.Entrance)) return true;
	if (!building.children.some((c) => c.type === RG_TYPE.Apartment)) return true;
	return false;
}
export { isBuildingEmpty };

//# sourceMappingURL=index81.js.map